import { render, staticRenderFns } from "./JourneyGroupItem.vue?vue&type=template&id=8463fbdc&scoped=true&"
import script from "./JourneyGroupItem.vue?vue&type=script&lang=js&"
export * from "./JourneyGroupItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8463fbdc",
  null
  
)

export default component.exports